import { useMemo } from 'react';
import { years } from '../../../../Common/Filters/Filters';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useUtilizationPerYearTotalChart = () => {
    const { chartData } = useServicesChartsDataContext();

    const series = useMemo(
        () =>
            ['Total de Utilização Anual'].map((item) => {
                const data = years.map((year) => {
                    const found = chartData.averageCounterYear.find(
                        (counter) => counter.ano_competencia === year
                    );

                    return found ? Number(found.total) : 0;
                });

                return {
                    name: item,
                    data
                };
            }),
        [chartData]
    );

    return {
        series,
        subtitles: years
    };
};

export default useUtilizationPerYearTotalChart;
